function cov_nj0kuiukv() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ShowerFilled.tsx";
  var hash = "c58befde50cb67787f1da79dafa41fefd658b379";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ShowerFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c58befde50cb67787f1da79dafa41fefd658b379"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nj0kuiukv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_nj0kuiukv();
var Icon = (cov_nj0kuiukv().s[0]++, {
  name: 'shower-filled',
  svg: "<path d=\"M20.7959 11.8465L17.2628 8.31348C17.7482 6.09103 19.7174 4.5 22 4.5V2C19.0557 2 16.4554 3.74669 15.2928 6.34345L12.5723 3.62292C10.4906 1.54129 7.07007 1.69965 5.18967 3.9647L4.66446 4.59735C4.00464 5.39214 4.05865 6.55864 4.78907 7.28907L17.2736 19.7736C18.1062 20.6062 19.4744 20.5429 20.2266 19.6368L21.1074 18.5758C22.757 16.5889 22.622 13.6726 20.7959 11.8465Z\" fill=\"currentColor\"/>\n  <path d=\"M9.38388 16.3839C9.87204 15.8957 9.87204 15.1043 9.38388 14.6161C8.89573 14.128 8.10427 14.128 7.61612 14.6161L2.11612 20.1161C1.62796 20.6043 1.62796 21.3957 2.11612 21.8839C2.60427 22.372 3.39573 22.372 3.88388 21.8839L9.38388 16.3839Z\" fill=\"currentColor\"/>\n  <path d=\"M12.8839 18.1161C13.372 18.6043 13.372 19.3957 12.8839 19.8839L10.3839 22.3839C9.89573 22.872 9.10427 22.872 8.61612 22.3839C8.12796 21.8957 8.12796 21.1043 8.61612 20.6161L11.1161 18.1161C11.6043 17.628 12.3957 17.628 12.8839 18.1161Z\" fill=\"currentColor\"/>\n  <path d=\"M5.88388 12.8839C6.37204 12.3957 6.37204 11.6043 5.88388 11.1161C5.39573 10.628 4.60427 10.628 4.11612 11.1161L1.61612 13.6161C1.12796 14.1043 1.12796 14.8957 1.61612 15.3839C2.10427 15.872 2.89573 15.872 3.38388 15.3839L5.88388 12.8839Z\" fill=\"currentColor\"/>"
});
export default Icon;